module.exports = __webpack_public_path__ + "img/JordanM-Part2.0f7aa3f2.png";